import React from 'react';
import classnames from 'classnames';
import { node, oneOfType, string, bool, number } from 'prop-types';
import styles from './Checkbox.scss';
import { withFocusable } from 'wix-style-react/dist/src/common/Focusable';

const Checkmark = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="8"
    viewBox="0 0 10 8"
    className={className}
    data-hook="checkmark"
  >
    <polygon points="3.5 5.2 1.2 3 0 4.2 3.5 7.8 10 1.2 8.8 0" />
  </svg>
);

const Indeterminate = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="8"
    viewBox="0 0 10 8"
    className={className}
    data-hook="indeterminate"
  >
    <rect fill="white" x="1" y="3" width="8" height="2" />
  </svg>
);

class Checkbox extends React.PureComponent {
  state = {};

  render() {
    const {
      children,
      className,
      dataHook,
      focusableOnFocus,
      focusableOnBlur,
      focusableIsFocused,
      focusableIsFocusVisible,
      checked,
      indeterminate,
      lineHeight,
      ...passThrough
    } = this.props;

    const checkboxSize = parseInt(styles.checkboxSize, 10);
    const marginTop = lineHeight && checkboxSize ? (lineHeight - checkboxSize) / 2 : 0;

    return (
      <label
        className={classnames([
          styles.label,
          className,
          focusableIsFocused && focusableIsFocusVisible && styles.focused,
        ])}
        data-hook={dataHook}
      >
        <input
          onBlur={focusableOnBlur}
          onFocus={focusableOnFocus}
          type="checkbox"
          checked={checked || indeterminate}
          {...passThrough}
          className={styles.checkbox}
        />
        <div className={styles.customCheckbox} style={{ marginTop }}>
          <div className={styles.checkmarkWrapper}>
            {indeterminate ? (
              <Indeterminate className={styles.indeterminate} />
            ) : (
              <Checkmark className={styles.checkmark} />
            )}
          </div>
        </div>
        <span className={styles.text}>{children}</span>
      </label>
    );
  }
}

Checkbox.propTypes = {
  className: string,
  children: oneOfType([string, node]),
  dataHook: string,
  checked: bool,
  indeterminate: bool,
  lineHeight: number,
};

Checkbox.defaultProps = {
  checked: false,
  indeterminate: false,
};

Checkbox.displayName = 'Checkbox';

export default withFocusable(Checkbox);
